module.exports = __webpack_public_path__ + "img/LV4.9815642e.png";